
import { defineComponent, PropType, ref, watchEffect } from 'vue';
import GlobalCurrencyIcon from '../icons/GlobalCurrencyIcon.vue';
import { formatNumberDecimals, RaceModel } from '../../../common';
import { config } from '../config';
import { EthersService as eth, convertToUSD } from '../services';
import { exchangeRatesAvailable, exchangeRates } from '../data/global';
import { notification } from '@/utils/notification.util';

export default defineComponent({
  name: 'LiveCard',
  components: {
    GlobalCurrencyIcon
  },
  props: {
    liveRace: {
      type: Object as PropType<RaceModel>,
      default: {},
      required: true
    },
    auxIndex: {
      type: Number,
      default: 0,
      required: true
    }
  },
  setup (props: any) {
    const race = ref<RaceModel>();
    const coverIndex = ref<number>(0);
    watchEffect(() => {
      race.value = new RaceModel(props.liveRace);
      coverIndex.value = race.value.race_id ? Number(race.value.race_id) % 7 : props.auxIndex;
    });

    const watchRace2D = () => {
      window.open(`${config.sim2dUrl}?raceId=${race.value.id}`);
    };

    const watchRace3D = () => {
      if (config.isMobile) {
        notification.create({
          title: '3D Simulation',
          description: 'You can only watch the 3D simulation on desktop.',
          type: 'info'
        });
        return;
      }
      window.open(`${config.sim3dUrl}?raceId=${race.value.id}&noGui=true&antialias=true&lights=true`);
    }

    return {
      raceCurrencyName: eth.currenciesInfo.find(c => c.value === race.value.entryFeeCurrency)?.label,
      watchRace2D,
      watchRace3D,
      race,
      coverIndex,
      sim2dUrl: config.sim2dUrl,
      formatNumberDecimals,
      eth,
      convertToUSD,
      exchangeRatesAvailable,
      exchangeRates,
      config
    };
  }
});
